<template>
  <v-main>
    <v-container fluid>
      <v-card elevation="6" rounded="xxl" v-if="!isLoading">
        <v-card-title class="mt-4">
          <v-btn
            class="mx-2"
            fab
            x-small
            color="primary"
            @click="$router.back()"
          >
            <v-icon dark> mdi-arrow-left </v-icon>
          </v-btn>
          Edit Daily Tip
        </v-card-title>
        <v-card-text>
          <v-row>
            <v-col sm="6">
              <v-menu
                v-model="tipDateMenu"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="auto"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    v-model="form.tip_date"
                    label="Tip Date *"
                    prepend-inner-icon="mdi-calendar"
                    readonly
                    outlined
                    v-bind="attrs"
                    v-on="on"
                    :error-messages="errors.tip_date"
                    clearable
                    @click:clear="form.tip_date = null"
                  ></v-text-field>
                </template>
                <v-date-picker
                  v-model="form.tip_date"
                  no-title
                  scrollable
                  @input="tipDateMenu = false"
                ></v-date-picker>
              </v-menu>
            </v-col>
            <v-col sm="6">
              <v-switch
                v-model="form.is_active"
                label="Active"
                inset
                color="success"
              ></v-switch>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.title"
                outlined
                label="Title *"
                prepend-inner-icon="mdi-lightbulb-on-outline"
                :error-messages="errors.title"
                counter="150"
                maxlength="150"
              ></v-text-field>
            </v-col>
            <v-col sm="6">
              <v-text-field
                v-model="form.summary"
                outlined
                label="Summary"
                prepend-inner-icon="mdi-subtitles"
                :error-messages="errors.summary"
                counter="255"
                maxlength="255"
              ></v-text-field>
            </v-col>
            <v-col cols="12">
              <v-textarea
                v-model="form.description"
                outlined
                label="Description"
                prepend-inner-icon="mdi-text"
                :error-messages="errors.description"
                rows="5"
                counter
              ></v-textarea>
            </v-col>
          </v-row>

          <v-divider class="mt-5 mb-5"></v-divider>
          <v-btn
            :loading="isSaving"
            :disabled="isSaving"
            rounded
            color="primary"
            dark
            @click="save"
          >
            Update Daily Tip
          </v-btn>
        </v-card-text>
      </v-card>

      <!-- Loading State -->
      <v-card elevation="6" rounded="xxl" v-else>
        <v-card-text class="text-center" style="height: 400px;">
          <health-loader message="Loading daily tip data..." />
        </v-card-text>
      </v-card>
    </v-container>
  </v-main>
</template>

<script>
import axios from "@/axios";

export default {
  name: "DailyTipEditPage",
  data() {
    return {
      form: {
        id: null,
        tip_date: null,
        title: "",
        summary: "",
        description: "",
        is_active: true,
      },
      errors: {},
      isLoading: true,
      isSaving: false,
      tipDateMenu: false,
    };
  },
  mounted() {
    this.getData();
  },
  methods: {
    async getData() {
      try {
        this.isLoading = true;
        const encryptedId = this.$route.params.id;
        const response = await axios.get(`/daily-tips/${encryptedId}`);

        if (response.data.success) {
          const tip = response.data.data;
          this.form = {
            id: tip.id,
            tip_date: tip.tip_date ? tip.tip_date.substring(0, 10) : null,
            title: tip.title,
            summary: tip.summary,
            description: tip.description,
            is_active: tip.is_active,
          };
        } else {
          this.$store.dispatch("errors/setError", {
            message: response.data.message || "Failed to load daily tip",
          });
          this.$router.push("/daily-tips");
        }
      } catch (error) {
        console.error("Error loading daily tip:", error);

        if (error.response && error.response.status === 404) {
          this.$store.dispatch("errors/setError", {
            message: "Daily tip not found",
          });
        } else if (error.response && error.response.status === 401) {
          this.$router.push("/login");
        } else {
          this.$store.dispatch("errors/setError", {
            message: "Error loading daily tip data",
          });
        }
        this.$router.push("/daily-tips");
      } finally {
        this.isLoading = false;
      }
    },

    async save() {
      try {
        this.isSaving = true;
        this.errors = {};

        const encryptedId = this.$route.params.id;
        const response = await axios.patch(`/daily-tips/${encryptedId}`, this.form);

        if (response.data.success) {
          this.$store.dispatch("errors/setSuccess", {
            message: "Daily tip updated successfully",
          });
          this.$router.push("/daily-tips");
        } else {
          this.$store.dispatch("errors/setError", {
            message: response.data.message || "Failed to update daily tip",
          });
        }
      } catch (error) {
        console.error("Error updating daily tip:", error);

        if (error.response && error.response.status === 422) {
          this.errors = error.response.data.errors || {};
        } else if (error.response && error.response.status === 401) {
          this.$router.push("/login");
        } else {
          this.$store.dispatch("errors/setError", {
            message: "Error updating daily tip",
          });
        }
      } finally {
        this.isSaving = false;
      }
    },
  },
};
</script>
